import posthog from "posthog-js";
import { isThirdPartyScriptException } from "@/lib/errors/thirdPartyNoise";

// fan-mily 共通 PostHog プロジェクト (id=384827 "fan-mily Apps")
const POSTHOG_TOKEN = "phc_vrNkZN8pnQWNg6wp7EQXM5wbrSvHqSLLgo58vD8QzsGf";

// 各イベントを app/repo で識別するため、setup.sh 実行時に icg-app/fan-mily-Inc/icg-app が置換される
const APP_NAME = "icg-app";
const REPO = "fan-mily-Inc/icg-app";

posthog.init(POSTHOG_TOKEN, {
  api_host: "/ingest",
  ui_host: "https://us.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  autocapture: false,
  capture_pageleave: true,
  debug: process.env.NODE_ENV === "development",
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: "[data-ph-mask]",
    sampleRate: 0.1,
  },
  // ブラウザ拡張 / in-app ブラウザが注入したスクリプト由来の例外は、
  // window.onerror 経由で自アプリの unhandled として捕捉されてしまうため
  // 送信前に落とす (#218)。
  before_send: (event) => {
    if (
      event?.event === "$exception" &&
      isThirdPartyScriptException(event.properties)
    ) {
      return null;
    }
    return event;
  },
});

posthog.register({
  app_name: APP_NAME,
  repo: REPO,
  environment: process.env.NODE_ENV ?? "unknown",
});

if (process.env.NODE_ENV === "production") {
  const originalConsoleError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    originalConsoleError(...args);
    try {
      const errArg = args.find((a): a is Error => a instanceof Error);
      const message =
        errArg?.message ??
        args
          .map((a) => (typeof a === "string" ? a : JSON.stringify(a)))
          .join(" ");
      posthog.captureException(errArg ?? new Error(message), {
        source: "console.error",
      });
    } catch {
    }
  };
}
